import React from 'react';
import Axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as Routes from '@/modules/routes';
import csrfToken from '../../shared/adminCsrf';
import RoutedSPADialog from '../../shared/RoutedSPADialog';
import StatesDialogContent, { StateOption } from '../StatesDialogContent';
import { useLessonSectionRows, usePatchSection } from './useSections';

const fetchStates = (sectionId: number) => Axios
  .get(Routes.get_states_admin_section_path(sectionId, { format: 'json' }))
  .then(({ data }): StateOption[] => data ?? []);

const saveStates = (sectionId: number, programId: number, stateIds: number[]) => Axios
  .post(
    Routes.set_states_admin_section_path(sectionId, { format: 'json', program_id: programId }),
    { section: { states: stateIds } },
    { headers: { 'X-CSRF-Token': csrfToken() } },
  )
  .then(({ data }): string => data?.selected ?? '');

// The legacy states modal on an enrichment section's View column, routed under the sections page.
const SectionStatesModal = () => {
  const navigate = useNavigate();
  const { lessonId, programId, sectionId } = useParams<{ lessonId: string; programId: string; sectionId: string }>();
  const pid = Number(programId);
  const lid = Number(lessonId);
  const id = Number(sectionId);
  const { data: rows = [] } = useLessonSectionRows(lid);
  const patchSection = usePatchSection(lid);
  const section = rows.find(row => row.id === id);

  const handleSaved = (label: string) => {
    patchSection(id, { states_selected: label });
    navigate('..');
  };

  return (
    <RoutedSPADialog>
      <StatesDialogContent
        description={section?.full_title}
        fetchStates={() => fetchStates(id)}
        saveStates={stateIds => saveStates(id, pid, stateIds)}
        title="Edit State-Specific Access"
        onSaved={handleSaved}
      />
    </RoutedSPADialog>
  );
};

export default SectionStatesModal;
